import React from 'react'
import LoginSection from './loginsection';
import HomeLayout from './homelayout';

const Home = ({history}) => (
    <HomeLayout>
        <LoginSection history={history}/>
    </HomeLayout>      
)

export default Home
